import React from 'react';
import { styledTheme } from 'components';

export interface IconGearProps {
  className?: string;
  color?: string;
  width?: number;
  height?: number;
}
export const IcoGear = ({ color, className, width = 16, height  = 16}: IconGearProps): JSX.Element => {
  height = height || width; // default height to be same as width if not provided
  color = color || styledTheme.color.main;

  className = `icon icon-gear ${className || ''}`.trim()
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.88333 2.878C7.16733 1.70733 8.83267 1.70733 9.11667 2.878C9.15928 3.05387 9.24281 3.21719 9.36047 3.35467C9.47813 3.49215 9.62659 3.5999 9.79377 3.66916C9.96094 3.73843 10.1421 3.76723 10.3225 3.75325C10.5029 3.73926 10.6775 3.68287 10.832 3.58867C11.8607 2.962 13.0387 4.13933 12.412 5.16867C12.3179 5.3231 12.2616 5.49756 12.2477 5.67785C12.2337 5.85814 12.2625 6.03918 12.3317 6.20625C12.4009 6.37333 12.5085 6.52172 12.6458 6.63937C12.7831 6.75702 12.9463 6.8406 13.122 6.88333C14.2927 7.16733 14.2927 8.83267 13.122 9.11667C12.9461 9.15928 12.7828 9.24281 12.6453 9.36047C12.5079 9.47813 12.4001 9.62659 12.3308 9.79377C12.2616 9.96094 12.2328 10.1421 12.2468 10.3225C12.2607 10.5029 12.3171 10.6775 12.4113 10.832C13.038 11.8607 11.8607 13.0387 10.8313 12.412C10.6769 12.3179 10.5024 12.2616 10.3222 12.2477C10.1419 12.2337 9.96082 12.2625 9.79375 12.3317C9.62667 12.4009 9.47828 12.5085 9.36063 12.6458C9.24298 12.7831 9.1594 12.9463 9.11667 13.122C8.83267 14.2927 7.16733 14.2927 6.88333 13.122C6.84072 12.9461 6.75719 12.7828 6.63953 12.6453C6.52187 12.5079 6.37341 12.4001 6.20623 12.3308C6.03906 12.2616 5.85789 12.2328 5.67748 12.2468C5.49706 12.2607 5.3225 12.3171 5.168 12.4113C4.13933 13.038 2.96133 11.8607 3.588 10.8313C3.68207 10.6769 3.73837 10.5024 3.75232 10.3222C3.76628 10.1419 3.7375 9.96082 3.66831 9.79375C3.59913 9.62667 3.49151 9.47828 3.35418 9.36063C3.21686 9.24298 3.05371 9.1594 2.878 9.11667C1.70733 8.83267 1.70733 7.16733 2.878 6.88333C3.05387 6.84072 3.21719 6.75719 3.35467 6.63953C3.49215 6.52187 3.5999 6.37341 3.66916 6.20623C3.73843 6.03906 3.76723 5.85789 3.75325 5.67748C3.73926 5.49706 3.68287 5.3225 3.58867 5.168C2.962 4.13933 4.13933 2.96133 5.16867 3.588C5.83533 3.99333 6.69933 3.63467 6.88333 2.878Z"
        stroke={color}
        strokeWidth="0.666667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 8C6 8.53043 6.21071 9.03914 6.58579 9.41421C6.96086 9.78929 7.46957 10 8 10C8.53043 10 9.03914 9.78929 9.41421 9.41421C9.78929 9.03914 10 8.53043 10 8C10 7.46957 9.78929 6.96086 9.41421 6.58579C9.03914 6.21071 8.53043 6 8 6C7.46957 6 6.96086 6.21071 6.58579 6.58579C6.21071 6.96086 6 7.46957 6 8Z"
        stroke={color}
        strokeWidth="0.666667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

// gear icon with ! in the middle
export const IcoGearWithExclamation = ({ color }: IconGearProps): JSX.Element => {
  color = color || styledTheme.color.main;
  return (
    <svg
      className="icon icon--gearWith-exclamation"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="M10.0027 12.2673C9.78914 12.3111 9.59247 12.4147 9.43559 12.566C9.27872 12.7174 9.16811 12.9102 9.11667 13.122C8.83267 14.2927 7.16733 14.2927 6.88333 13.122C6.84072 12.9461 6.75719 12.7828 6.63953 12.6453C6.52187 12.5079 6.37341 12.4001 6.20623 12.3308C6.03906 12.2616 5.85789 12.2328 5.67748 12.2468C5.49706 12.2607 5.3225 12.3171 5.168 12.4113C4.13933 13.038 2.96133 11.8607 3.588 10.8313C3.68207 10.6769 3.73837 10.5024 3.75232 10.3222C3.76628 10.1419 3.7375 9.96082 3.66831 9.79375C3.59913 9.62667 3.49151 9.47828 3.35418 9.36063C3.21686 9.24298 3.05371 9.1594 2.878 9.11667C1.70733 8.83267 1.70733 7.16733 2.878 6.88333C3.05387 6.84072 3.21719 6.75719 3.35467 6.63953C3.49215 6.52187 3.5999 6.37341 3.66916 6.20623C3.73843 6.03906 3.76723 5.85789 3.75325 5.67748C3.73926 5.49706 3.68287 5.3225 3.58867 5.168C2.962 4.13933 4.13933 2.96133 5.16867 3.588C5.83533 3.99333 6.69933 3.63467 6.88333 2.878C7.16733 1.70733 8.83267 1.70733 9.11667 2.878C9.15928 3.05387 9.24281 3.21719 9.36047 3.35467C9.47813 3.49215 9.62659 3.5999 9.79377 3.66916C9.96094 3.73843 10.1421 3.76723 10.3225 3.75325C10.5029 3.73926 10.6775 3.68287 10.832 3.58867C11.8607 2.962 13.0387 4.13933 12.412 5.16867C12.3179 5.3231 12.2616 5.49756 12.2477 5.67785C12.2337 5.85814 12.2625 6.03918 12.3317 6.20625C12.4009 6.37333 12.5085 6.52172 12.6458 6.63937C12.7831 6.75702 12.9463 6.8406 13.122 6.88333C13.8413 7.058 14.1187 7.75333 13.954 8.33"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6 8C6 8.53043 6.21071 9.03914 6.58579 9.41421C6.96086 9.78929 7.46957 10 8 10C8.53043 10 9.03914 9.78929 9.41421 9.41421C9.78929 9.03914 10 8.53043 10 8C10 7.46957 9.78929 6.96086 9.41421 6.58579C9.03914 6.21071 8.53043 6 8 6C7.46957 6 6.96086 6.21071 6.58579 6.58579C6.21071 6.96086 6 7.46957 6 8Z"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.668 10.668V12.668"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.668 14.668V14.6746"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};
// gear icon with ! in the middle
export const IcoBlueGear = (
  <svg
    className="icon icon--blue-gear"
    width="142"
    height="145"
    viewBox="0 0 142 145"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_dd_10646_96443)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M54.1886 3C54.1886 1.89543 55.084 1 56.1886 1H65.8895C66.9941 1 67.8895 1.89543 67.8895 3V8.06431C67.8895 9.05102 68.6103 9.88573 69.5794 10.0715C76.1324 11.328 82.2067 13.9311 87.5034 17.5816C88.3206 18.1448 89.4282 18.0677 90.13 17.3659L94.1209 13.375C94.902 12.5939 96.1683 12.5939 96.9493 13.375L103.809 20.2346C104.59 21.0157 104.59 22.282 103.809 23.0631L99.8391 27.033C99.1355 27.7366 99.06 28.8479 99.6274 29.6653C103.325 34.9926 105.961 41.1132 107.228 47.7201C107.414 48.6892 108.248 49.41 109.235 49.41H114.299C115.404 49.41 116.299 50.3054 116.299 51.41V61.1109C116.299 62.2155 115.404 63.1109 114.299 63.1109H109.401C108.4 63.1109 107.557 63.8528 107.387 64.8397C106.196 71.7542 103.509 78.157 99.6728 83.7037C99.1075 84.521 99.1837 85.6304 99.8864 86.3331L102.896 89.3425C103.677 90.1236 103.677 91.3899 102.896 92.1709L96.0362 99.0306C95.2551 99.8117 93.9888 99.8117 93.2077 99.0306L90.1983 96.0212C89.4957 95.3185 88.3862 95.2422 87.5689 95.8075C82.2569 99.4818 76.1594 102.101 69.5794 103.363C68.6103 103.549 67.8895 104.383 67.8895 105.37V110.434C67.8895 111.539 66.9941 112.434 65.8895 112.434H56.1886C55.084 112.434 54.1886 111.539 54.1886 110.434V105.536C54.1886 104.535 53.4467 103.692 52.4597 103.522C45.5317 102.328 39.1172 99.6335 33.5629 95.7848C32.7456 95.2185 31.6352 95.2944 30.9321 95.9975L27.8415 99.0881C27.0604 99.8692 25.7941 99.8692 25.013 99.0881L18.1534 92.2285C17.3723 91.4474 17.3723 90.1811 18.1534 89.4L21.2546 86.2988C21.9568 85.5966 22.0335 84.488 21.4693 83.6708C17.6448 78.1318 14.9666 71.7405 13.7775 64.8397C13.6075 63.8528 12.765 63.1109 11.7635 63.1109H6.86523C5.76066 63.1109 4.86523 62.2155 4.86523 61.1109V51.41C4.86523 50.3054 5.76066 49.41 6.86523 49.41H11.9295C12.9162 49.41 13.751 48.6891 13.9368 47.7201C15.2188 41.0333 17.903 34.8448 21.6715 29.4725C22.2451 28.6547 22.1722 27.5381 21.4658 26.8318L17.7546 23.1206C16.9736 22.3395 16.9736 21.0732 17.7546 20.2922L24.6143 13.4325C25.3954 12.6514 26.6617 12.6514 27.4427 13.4325L31.2371 17.2268C31.9361 17.9258 33.0383 18.0054 33.8551 17.4484C39.3416 13.7069 45.653 11.0853 52.4598 9.91232C53.4467 9.74224 54.1886 8.89974 54.1886 7.89825V3ZM60.5824 89.5994C78.7428 89.5994 93.4646 74.8775 93.4646 56.7171C93.4646 38.5567 78.7428 23.8349 60.5824 23.8349C42.4219 23.8349 27.7001 38.5567 27.7001 56.7171C27.7001 74.8775 42.4219 89.5994 60.5824 89.5994Z"
        fill="white"
      />
    </g>
    <g filter="url(#filter1_b_10646_96443)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M54.1886 3C54.1886 1.89543 55.084 1 56.1886 1H65.8895C66.9941 1 67.8895 1.89543 67.8895 3V8.06431C67.8895 9.05102 68.6103 9.88573 69.5794 10.0715C76.1324 11.328 82.2067 13.9311 87.5034 17.5816C88.3206 18.1448 89.4282 18.0677 90.13 17.3659L94.1209 13.375C94.902 12.5939 96.1683 12.5939 96.9493 13.375L103.809 20.2346C104.59 21.0157 104.59 22.282 103.809 23.0631L99.8391 27.033C99.1355 27.7366 99.06 28.8479 99.6274 29.6653C103.325 34.9926 105.961 41.1132 107.228 47.7201C107.414 48.6892 108.248 49.41 109.235 49.41H114.299C115.404 49.41 116.299 50.3054 116.299 51.41V61.1109C116.299 62.2155 115.404 63.1109 114.299 63.1109H109.401C108.4 63.1109 107.557 63.8528 107.387 64.8397C106.196 71.7542 103.509 78.157 99.6728 83.7037C99.1075 84.521 99.1837 85.6304 99.8864 86.3331L102.896 89.3425C103.677 90.1236 103.677 91.3899 102.896 92.1709L96.0362 99.0306C95.2551 99.8117 93.9888 99.8117 93.2077 99.0306L90.1983 96.0212C89.4957 95.3185 88.3862 95.2422 87.5689 95.8075C82.2569 99.4818 76.1594 102.101 69.5794 103.363C68.6103 103.549 67.8895 104.383 67.8895 105.37V110.434C67.8895 111.539 66.9941 112.434 65.8895 112.434H56.1886C55.084 112.434 54.1886 111.539 54.1886 110.434V105.536C54.1886 104.535 53.4467 103.692 52.4597 103.522C45.5317 102.328 39.1172 99.6335 33.5629 95.7848C32.7456 95.2185 31.6352 95.2944 30.9321 95.9975L27.8415 99.0881C27.0604 99.8692 25.7941 99.8692 25.013 99.0881L18.1534 92.2285C17.3723 91.4474 17.3723 90.1811 18.1534 89.4L21.2546 86.2988C21.9568 85.5966 22.0335 84.488 21.4693 83.6708C17.6448 78.1318 14.9666 71.7405 13.7775 64.8397C13.6075 63.8528 12.765 63.1109 11.7635 63.1109H6.86523C5.76066 63.1109 4.86523 62.2155 4.86523 61.1109V51.41C4.86523 50.3054 5.76066 49.41 6.86523 49.41H11.9295C12.9162 49.41 13.751 48.6891 13.9368 47.7201C15.2188 41.0333 17.903 34.8448 21.6715 29.4725C22.2451 28.6547 22.1722 27.5381 21.4658 26.8318L17.7546 23.1206C16.9736 22.3395 16.9736 21.0732 17.7546 20.2922L24.6143 13.4325C25.3954 12.6514 26.6617 12.6514 27.4427 13.4325L31.2371 17.2268C31.9361 17.9258 33.0383 18.0054 33.8551 17.4484C39.3416 13.7069 45.653 11.0853 52.4598 9.91232C53.4467 9.74224 54.1886 8.89974 54.1886 7.89825V3ZM60.5824 89.5994C78.7428 89.5994 93.4646 74.8775 93.4646 56.7171C93.4646 38.5567 78.7428 23.8349 60.5824 23.8349C42.4219 23.8349 27.7001 38.5567 27.7001 56.7171C27.7001 74.8775 42.4219 89.5994 60.5824 89.5994Z"
        fill="#0076CC"
      />
    </g>
    <g filter="url(#filter2_ii_10646_96443)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M54.1886 3C54.1886 1.89543 55.084 1 56.1886 1H65.8895C66.9941 1 67.8895 1.89543 67.8895 3V8.06431C67.8895 9.05102 68.6103 9.88573 69.5794 10.0715C76.1324 11.328 82.2067 13.9311 87.5034 17.5816C88.3206 18.1448 89.4282 18.0677 90.13 17.3659L94.1209 13.375C94.902 12.5939 96.1683 12.5939 96.9493 13.375L103.809 20.2346C104.59 21.0157 104.59 22.282 103.809 23.0631L99.8391 27.033C99.1355 27.7366 99.06 28.8479 99.6274 29.6653C103.325 34.9926 105.961 41.1132 107.228 47.7201C107.414 48.6892 108.248 49.41 109.235 49.41H114.299C115.404 49.41 116.299 50.3054 116.299 51.41V61.1109C116.299 62.2155 115.404 63.1109 114.299 63.1109H109.401C108.4 63.1109 107.557 63.8528 107.387 64.8397C106.196 71.7542 103.509 78.157 99.6728 83.7037C99.1075 84.521 99.1837 85.6304 99.8864 86.3331L102.896 89.3425C103.677 90.1236 103.677 91.3899 102.896 92.1709L96.0362 99.0306C95.2551 99.8117 93.9888 99.8117 93.2077 99.0306L90.1983 96.0212C89.4957 95.3185 88.3862 95.2422 87.5689 95.8075C82.2569 99.4818 76.1594 102.101 69.5794 103.363C68.6103 103.549 67.8895 104.383 67.8895 105.37V110.434C67.8895 111.539 66.9941 112.434 65.8895 112.434H56.1886C55.084 112.434 54.1886 111.539 54.1886 110.434V105.536C54.1886 104.535 53.4467 103.692 52.4597 103.522C45.5317 102.328 39.1172 99.6335 33.5629 95.7848C32.7456 95.2185 31.6352 95.2944 30.9321 95.9975L27.8415 99.0881C27.0604 99.8692 25.7941 99.8692 25.013 99.0881L18.1534 92.2285C17.3723 91.4474 17.3723 90.1811 18.1534 89.4L21.2546 86.2988C21.9568 85.5966 22.0335 84.488 21.4693 83.6708C17.6448 78.1318 14.9666 71.7405 13.7775 64.8397C13.6075 63.8528 12.765 63.1109 11.7635 63.1109H6.86523C5.76066 63.1109 4.86523 62.2155 4.86523 61.1109V51.41C4.86523 50.3054 5.76066 49.41 6.86523 49.41H11.9295C12.9162 49.41 13.751 48.6891 13.9368 47.7201C15.2188 41.0333 17.903 34.8448 21.6715 29.4725C22.2451 28.6547 22.1722 27.5381 21.4658 26.8318L17.7546 23.1206C16.9736 22.3395 16.9736 21.0732 17.7546 20.2922L24.6143 13.4325C25.3954 12.6514 26.6617 12.6514 27.4427 13.4325L31.2371 17.2268C31.9361 17.9258 33.0383 18.0054 33.8551 17.4484C39.3416 13.7069 45.653 11.0853 52.4598 9.91232C53.4467 9.74224 54.1886 8.89974 54.1886 7.89825V3ZM60.5824 89.5994C78.7428 89.5994 93.4646 74.8775 93.4646 56.7171C93.4646 38.5567 78.7428 23.8349 60.5824 23.8349C42.4219 23.8349 27.7001 38.5567 27.7001 56.7171C27.7001 74.8775 42.4219 89.5994 60.5824 89.5994Z"
        fill="#A3A3A3"
      />
    </g>
    <g filter="url(#filter3_d_10646_96443)">
      <g filter="url(#filter4_b_10646_96443)">
        <path
          d="M137.284 99.4651C137.284 120.092 120.562 136.814 99.935 136.814C79.3078 136.814 62.5862 120.092 62.5862 99.4651C62.5862 78.838 79.3078 62.1163 99.935 62.1163C120.562 62.1163 137.284 78.838 137.284 99.4651ZM76.7446 99.4651C76.7446 112.273 87.1273 122.655 99.935 122.655C112.743 122.655 123.125 112.273 123.125 99.4651C123.125 86.6575 112.743 76.2748 99.935 76.2748C87.1273 76.2748 76.7446 86.6575 76.7446 99.4651Z"
          fill="#0076CC"
        />
      </g>
      <path
        d="M136.172 108.51C137.566 102.925 137.65 97.0925 136.418 91.4691C135.185 85.8457 132.67 80.5833 129.067 76.093C125.464 71.6026 120.873 68.0058 115.65 65.5835C110.428 63.1612 104.716 61.9789 98.9611 62.129L99.3291 76.2362C102.91 76.1428 106.463 76.8783 109.712 78.3854C112.962 79.8925 115.818 82.1302 118.06 84.924C120.301 87.7177 121.866 90.9917 122.633 94.4903C123.4 97.989 123.348 101.618 122.48 105.093L136.172 108.51Z"
        fill="#004577"
      />
    </g>
    <defs>
      <filter
        id="filter0_dd_10646_96443"
        x="0.865234"
        y="0"
        width="119.434"
        height="119.434"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="3" />
        <feGaussianBlur stdDeviation="1.5" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_10646_96443" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="3" />
        <feGaussianBlur stdDeviation="2" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0" />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_10646_96443"
          result="effect2_dropShadow_10646_96443"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_10646_96443"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_b_10646_96443"
        x="2.86523"
        y="-1"
        width="115.434"
        height="115.434"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation="1" />
        <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_10646_96443" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_backgroundBlur_10646_96443"
          result="shape"
        />
      </filter>
      <filter
        id="filter2_ii_10646_96443"
        x="4.86523"
        y="1"
        width="111.434"
        height="111.434"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.196112 0 0 0 0 0.628811 0 0 0 0 0.960547 0 0 0 1 0"
        />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_10646_96443" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0.480026 0 0 0 0 0.848047 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_innerShadow_10646_96443"
          result="effect2_innerShadow_10646_96443"
        />
      </filter>
      <filter
        id="filter3_d_10646_96443"
        x="58.5862"
        y="62.1163"
        width="82.6976"
        height="82.6976"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_10646_96443" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_10646_96443"
          result="shape"
        />
      </filter>
      <filter
        id="filter4_b_10646_96443"
        x="60.5862"
        y="60.1163"
        width="78.6976"
        height="78.6976"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation="1" />
        <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_10646_96443" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_backgroundBlur_10646_96443"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export const IcoGearWithBoxes = ({ color }: { color?: string }): JSX.Element => {
  color = color || 'white';

  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="icon icon-gear-with-boxes"
    >
      <path
        d="M13.2164 14.6035V9.07873C13.2164 8.81231 13.3213 8.55681 13.5081 8.36843C13.6949 8.18005 13.9482 8.07422 14.2123 8.07422H20.1879C20.452 8.07422 20.7053 8.18005 20.8921 8.36843C21.0789 8.55681 21.1838 8.81231 21.1838 9.07873V12.0923"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.196 8.07174V5.05822C18.196 4.79181 18.0911 4.53631 17.9043 4.34792C17.7176 4.15954 17.4643 4.05371 17.2001 4.05371H4.25311C3.98898 4.05371 3.73566 4.15954 3.54889 4.34792C3.36211 4.53631 3.25719 4.79181 3.25719 5.05822V17.1123C3.25719 17.3787 3.36211 17.6342 3.54889 17.8226C3.73566 18.011 3.98898 18.1168 4.25311 18.1168H12.2205"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.2042 9.07812H18.196"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.2021 19.1243C17.2021 19.6571 17.4119 20.1681 17.7855 20.5448C18.159 20.9216 18.6656 21.1333 19.1939 21.1333C19.7222 21.1333 20.2288 20.9216 20.6024 20.5448C20.9759 20.1681 21.1858 19.6571 21.1858 19.1243C21.1858 18.5914 20.9759 18.0804 20.6024 17.7037C20.2288 17.3269 19.7222 17.1152 19.1939 17.1152C18.6656 17.1152 18.159 17.3269 17.7855 17.7037C17.4119 18.0804 17.2021 18.5914 17.2021 19.1243Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.1939 15.6084V17.1152"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.1939 21.1328V22.6396"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.211 17.3652L20.9173 18.1191"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.4697 20.1289L16.175 20.8828"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.175 17.3652L17.4697 18.1191"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.9173 20.1289L22.212 20.8828"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
